import { useEffect } from 'react';
import { useSharedState } from '../config/FarmContext';
import UserSettingService from '../services/userSettingService';
import FarmService from '../services/farmService';
import { useNavigate } from 'react-router-dom';

const userSettingService = new UserSettingService();
const farmService = new FarmService();

const useLoadUserSettings = () => {
  const { setUserSettings, setFarm, setFarms, setIsReady } = useSharedState();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserSettings = async () => {

      try{
        const farms = await farmService.getFarms()
        if (farms && farms.length > 0) {
          setFarms(farms)
        } else {
          setIsReady(true);
          navigate('/betrieb');
          setIsReady(true);
          return;
        }
  
        try {
          const userSettings = await userSettingService.getUserSettings();
          if (userSettings && userSettings.currentFarmId) {
            const farm = farms.find((farm) => farm.id === userSettings.currentFarmId);
            setFarm(farm);
          }
          setUserSettings(userSettings);
        } catch (error) {
        }
  
        setIsReady(true);
      }catch (error: any){
        console.error("application not ready")
        navigate('/error');

      }

     
    };

    fetchUserSettings();
  }, []);
};

export default useLoadUserSettings;